import React, { useState } from 'react';
import { useButtonLinks } from '../hooks/useButtonLinks';
import { useTranslation } from '../hooks/useTranslation';
import './Support.css';

const Support = () => {
  const { handleButtonLinks } = useButtonLinks();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // You can integrate with your backend API here
    alert(t('support.contactForm.successMessage'));
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="support-page">
      {/* Hero Section */}
      <section className="support-hero">
        <div className="container">
          <div className="support-content">
            <div className="support-text">
              <h1>{t('support.hero.title')}</h1>
            </div>
            
            <div className="support-main-content">
              {/* Global Offices Section */}
              <div className="global-offices">
                <h2>{t('support.offices.title')}</h2>
                
                <div className="offices-grid">
                  {/* Saint Vincent Office */}
                  <div className="office-card">
                    <div className="office-header">
                      <h3>{t('support.offices.saintVincent.name')}</h3>
                    </div>
                    <div className="office-address">
                      <div className="address-item">
                        <i className="fas fa-map-marker-alt"></i>
                        <div className="address-details">
                          <p>{t('support.offices.saintVincent.address.line1')}</p>
                          <p>{t('support.offices.saintVincent.address.line2')}</p>
                          <p>{t('support.offices.saintVincent.address.line3')}</p>
                        </div>
                      </div>
                    </div>
                    <div className="office-regulation">
                      <div className="regulation-item">
                        <i className="fas fa-certificate"></i>
                        <p>{t('support.offices.saintVincent.regulation')}</p>
                      </div>
                    </div>
                  </div>

                  {/* Malaysia Office */}
                  <div className="office-card">
                    <div className="office-header">
                      <h3>{t('support.offices.malaysia.name')}</h3>
                    </div>
                    <div className="office-address">
                      <div className="address-item">
                        <i className="fas fa-map-marker-alt"></i>
                        <div className="address-details">
                          <p>{t('support.offices.malaysia.address.line1')}</p>
                          <p>{t('support.offices.malaysia.address.line2')}</p>
                          <p>{t('support.offices.malaysia.address.line3')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="contact-form-section">
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        placeholder={t('support.contactForm.placeholders.name')}
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        placeholder={t('support.contactForm.placeholders.email')}
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">{t('support.contactForm.subject.label')}</option>
                      <option value="general">{t('support.contactForm.subject.options.general')}</option>
                      <option value="account">{t('support.contactForm.subject.options.account')}</option>
                      <option value="trading">{t('support.contactForm.subject.options.trading')}</option>
                      <option value="technical">{t('support.contactForm.subject.options.technical')}</option>
                      <option value="compliance">{t('support.contactForm.subject.options.compliance')}</option>
                      <option value="partnership">{t('support.contactForm.subject.options.partnership')}</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <textarea
                      name="message"
                      placeholder={t('support.contactForm.placeholders.message')}
                      rows="6"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary btn-large">
                    {t('support.contactForm.submitButton')}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Support;